<template>
  <div class="article-artwork" :class="[`artwork-${topic.toLowerCase()}`, { 'article-artwork-placeholder': !item.image }]">
    <Image v-if="item.image" :src="item.image" :alt="item.title" :width="768" class="article-cover-image" />
    <div v-else class="article-type-art" aria-hidden="true">
      <span class="artwork-orbit" />
      <span class="artwork-grid" />
      <div class="artwork-window">
        <div class="artwork-window-bar">
          <span>▸ {{ topic.toLowerCase() }}.notes</span>
          <span>− □ ×</span>
        </div>
        <div class="artwork-window-content">
          {{ symbols[topic] || '{ … }' }}
          <span class="artwork-cursor">_</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { Article } from '~/types/article'
import { articleTopic } from '~/helpers/articleTopic'
const props = defineProps<{ item: Article }>()
const topic = computed(() => articleTopic(props.item))
const symbols: Record<string, string> = {
  Cypress: 'cy.get()',
  Playwright: 'await',
  AI: '> hello',
  Testing: '{ … }',
  Career: 'hello.'
}
</script>
